import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamGroupDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-group-detail',
	path: '/jira/ops/teams/:teamId/group-detail/:id',
	exact: true,
};
